// Makes requests to CryptoCompare API
export async function getCompanies() {
    try {
        const response = await fetch("/tradefloor/api/companies");

        return response.json();
    } catch (error) {
        throw new Error("CryptoCompare request error: ${error.status}");
    }
}

export function parseFullSymbol1(fullSymbol: string) {
    const myArray = fullSymbol.split(":");
    return { code: myArray[0], exchange: myArray[1]};
}